module.exports = __webpack_public_path__ + "img/symbol_0.d1f6565a.png";